/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Rest_TitleInputs */

const en_us2_offline_rest_title = /** @type {(inputs: Offline_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest is over`)
};

const pt_br2_offline_rest_title = /** @type {(inputs: Offline_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descanso acabou`)
};

const es_419_offline_rest_title = /** @type {(inputs: Offline_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminó el descanso`)
};

const pt_pt2_offline_rest_title = /** @type {(inputs: Offline_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O descanso acabou`)
};

const fr_fr2_offline_rest_title = /** @type {(inputs: Offline_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repos terminé`)
};

const de_de2_offline_rest_title = /** @type {(inputs: Offline_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause vorbei`)
};

const it_it2_offline_rest_title = /** @type {(inputs: Offline_Rest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero finito`)
};

/**
* | output |
* | --- |
* | "Rest is over" |
*
* @param {Offline_Rest_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_rest_title = /** @type {((inputs?: Offline_Rest_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Rest_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_rest_title(inputs)
	if (locale === "es-419") return es_419_offline_rest_title(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_rest_title(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_rest_title(inputs)
	if (locale === "de-DE") return de_de2_offline_rest_title(inputs)
	if (locale === "it-IT") return it_it2_offline_rest_title(inputs)
	return en_us2_offline_rest_title(inputs)
});
export { offline_rest_title as "offline.rest_title" }